module.exports = __webpack_public_path__ + "static/media/shekel-sign.1894de14.svg";